export const en = {
    'currency-cost-shows': '{currency} per thousand impressions \\n',
    'rate-note': 'Maximum bid for new and changed impression criteria'
};
